import { call, put, takeEvery } from "redux-saga/effects";
import { datadogRum } from "@datadog/browser-rum";
import {
  REQUEST_FEATURE_FLAGS,
  requestFeatureFlagsError,
  requestFeatureFlagsSuccess,
} from "../action/launchDarklyFeatureFlags-action";
import { getFeatureFlagSet } from "../api";
import { AMC, JJ } from "../app-consts/appConstants";
export function* requestFeatureFlagSaga() {
  try {
    const url = window.location.pathname.split("/");
    const isOmniPath = url[1] === "OmniAssist";
    const isOneAppPath = url[1] === "member" && url[2] === "oneapp";
    const benefitsPath = url[1] === "benefits";
    const isAMCJJMemberPath =
      (url[2] === AMC || url[2] === JJ) && url[1] === "member";
    let payload = { kind: "user", key: "test" };
    let searchParams;
    let resp;

    if (isOmniPath) {
      searchParams = new URLSearchParams(window.location.search);
      payload.key = searchParams.get("conversationId");
    } else if (isOneAppPath) {
      searchParams = new URLSearchParams(window.location.search);
      payload.key = searchParams.get("session");
    } else if (benefitsPath) {
      payload.key = localStorage.getItem("benefitSession");
    }

    if (!isAMCJJMemberPath) {
      resp = yield call(getFeatureFlagSet, payload);
      yield put(requestFeatureFlagsSuccess(resp.data));
    } else {
      yield put(requestFeatureFlagsSuccess("false"));
    }

    const experimentGroup = resp.data.enableChatBot;
    datadogRum.addAction("Experiment Group Set", {
      experimentGroup: experimentGroup ? "Experiment" : "Control",
    });
  } catch (e) {
    datadogRum.addError(new Error(`Could not get feature flags ${e}`));
    yield put(requestFeatureFlagsError(e));
  }
}

export function* watchFeatureFlagSaga() {
  yield takeEvery(REQUEST_FEATURE_FLAGS, requestFeatureFlagSaga);
}
